import { render, staticRenderFns } from "./WelcomeBox20.vue?vue&type=template&id=10d2afcb&scoped=true"
import script from "./WelcomeBox20.vue?vue&type=script&lang=js"
export * from "./WelcomeBox20.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBox20.vue?vue&type=style&index=0&id=10d2afcb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d2afcb",
  null
  
)

export default component.exports